import { useId } from "react";
import { G, TIMING } from "./geometry.js";
import { PandaMarkCompact } from "./PandaMarkCompact.js";

/**
 * PandaTaps mark — reproduced exactly from the shipping face. Static.
 * Switches to PandaMarkCompact under 32px unless `compact={false}`.
 */
export function PandaMark({ size = 24, ink = "#000000", face = "#FFFFFF", title = undefined, compact = "auto", ...rest }) {
  const id = useId().replace(/:/g, "");
  if (compact === true || (compact === "auto" && size < TIMING.compactBelow)) {
    return <PandaMarkCompact size={size} ink={ink} face={face} title={title} {...rest} />;
  }
  const a11y = title ? { role: "img", "aria-labelledby": `${id}-t` } : { "aria-hidden": "true", focusable: "false" };
  const { face: f, earL, earR, patchL, patchR, eyeL, eyeR, pupilL, pupilR, blushL, blushR, nose } = G;
  return (
    <svg width={size} height={size} viewBox={G.viewBox} xmlns="http://www.w3.org/2000/svg" {...a11y} {...rest}>
      {title && <title id={`${id}-t`}>{title}</title>}
      <circle {...f} fill={face} />
      <circle {...earL} fill={ink} />
      <circle {...earR} fill={ink} />
      <circle {...patchL} fill={ink} />
      <circle {...patchR} fill={ink} />
      <circle {...eyeL} fill={face} />
      <circle {...pupilL} fill={ink} />
      <circle {...eyeR} fill={face} />
      <circle {...pupilR} fill={ink} />
      <circle {...blushL} fill={G.blush} opacity={G.blushOpacity} />
      <circle {...blushR} fill={G.blush} opacity={G.blushOpacity} />
      <ellipse {...nose} fill={ink} />
      <path d={G.mouth} fill="none" stroke={ink} strokeWidth={G.mouthStroke} />
    </svg>
  );
}

export default PandaMark;
